module.exports = __webpack_public_path__ + "img/mariafernandavaldes.740db624.jpg";